import IHcImage from "@/module/main/dto/financing-v1/IHcImage";

export default class HcImage implements IHcImage
{
    constructor(public filename?: string,
                public url?: string,
                public content?: string)
    {
    }
}
